import {Base} from "../Base";
import {Box, Button, Container, Link, Paper, Stack, TextField} from "@mui/material";
import {Link as RouterLink} from "react-router-dom"
import styled from "styled-components";
import {useContext, useEffect, useState} from "react";
import {PostLogin} from "../api/AuthenticationApi";
import {AppContext} from "../App";
import {useCookies} from "react-cookie";
import {TokenExpirationCookie, UserSession} from "../domain/Cookie";

const NoteText = styled.span`
font-size:0.9em;`

export const LoginPage = () => {

  const [mail, setMail] = useState<string>("")
  const [pass, setPass] = useState<string>("")
  const {state, dispatch} = useContext(AppContext);
  const [cookies] = useCookies([TokenExpirationCookie, UserSession])

  const checkAlreadyLogin = () => {
    //これが存在するならrefresh可能=ログイン中
    // 20220724時点では完全移行できておらず、なぜかリフレッシュできない自体が発生しているためuser_sessionでも判定する
    return cookies.token_expiration != null && cookies.user_session != null
  }

  const handleLoginButtonClick = async () => {
    try {
      await PostLogin(mail, pass)
      window.location.href = "/user_baby"
    } catch (e: any) {
      dispatch({type: "setError", payload: {error: true, message: e.message}})
    }
  }

  useEffect(() => {
    if (checkAlreadyLogin()) {
      window.location.href = "/user_baby"
    }
  }, [])

  return <Base>
    <Paper>
      <Container maxWidth={"sm"}>
        <Box p={1}>
          <TextField variant={"standard"} label={"メールアドレス"} value={mail} onChange={e => setMail(e.target.value)}
                     fullWidth/>
        </Box>
        <Box p={1}>
          <TextField variant={"standard"} label={"パスワード"} type={"password"} value={pass}
                     onChange={e => setPass(e.target.value)}
                     fullWidth/>
        </Box>
        <Box p={1} display={"flex"} justifyContent={"center"}>
          <Button variant={"contained"} onClick={handleLoginButtonClick}>ログイン</Button>
        </Box>
        <Stack p={1} direction={"row"} spacing={1} display={"flex"} justifyContent={"center"}>
          <Link href={"/register"}><NoteText>新しいアカウントを作成</NoteText></Link>
          <Link href={"/password"}><NoteText>パスワードを忘れた場合</NoteText></Link>
        </Stack>
      </Container>
    </Paper>
  </Base>
}